export const autocompleteTheme = {
  extend: {
    agility: {
      gap: 'var(--half-rem)',
    },
  },
  css: ({ dt }: any) => `
  .p-autocomplete .p-autocomplete-input-multiple {
    gap: ${dt('autocomplete.agility.gap')} !important;
  }
  `,
};
